import { useState } from "react";
import AboutPage from "./pages/about";
import OurBussinessPage from "./pages/our-bussiness";
import StationsPage from "./pages/stations";
import DownloadPage from "./pages/download";

const Tabs = ({ index, data, lang }) => {
    console.log("index", index)
    console.log("data", data)
    console.log("lang", lang)
    const [sites] = useState([
        <AboutPage data={data} lang={lang} />,
        <StationsPage data={data} lang={lang} />,
        <OurBussinessPage data={data} lang={lang} />,
        <DownloadPage data={data} lang={lang} />,
    ])

    return sites[index - 1]
}

export default Tabs
